module.exports = __webpack_public_path__ + "static/img/empty-order.e8515358.png";